import React, { useContext, useEffect, useState } from 'react'
import { Outlet, useLocation, Link, useNavigate } from 'react-router-dom';
import { DContext } from '../context/Datacontext';
import Loading from '../features/Loading';
import { fetchStudentProfile } from '../services/user/fetchStudentProfile';
import {
    FiMenu,
    FiX,
    FiBook,
    FiShoppingCart,
    FiAward,
    FiLogOut,
    FiBell,
    FiChevronDown,
} from 'react-icons/fi';
import Logo from '../assets/WhatsApp Image 2025-12-17 at 3.56.49 PM.jpeg'

function StudentLayout() {
    const { BeURL, isAuth, currentUser, handleLogout } = useContext(DContext)
    const [student, setStudent] = useState(null);
    const [loading, setLoading] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(false); 
    const [userMenuOpen, setUserMenuOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate()

    useEffect(() => {
        if (!BeURL || !currentUser) return;

        if (isAuth === false) {
            navigate('/')
            return;
        }

        if (location.pathname === '/learner/profile') {
            setLoading(false);
            return;
        }

        if (currentUser?.role !== 'user') {
            setTimeout(() => {
                window.location.href = '/app/dashboard';
            }, 500)
            setLoading(false);
            return;
        }

        const fetchStudentData = async () => {
            const userInfo = await fetchStudentProfile({ BeURL })
            setLoading(false);
            if (!userInfo.success) {
                alert('Complete your profile to access the dashboard');
                setTimeout(() => {
                    window.location.href = '/learner/profile';
                }, 500)
            }
            setStudent(userInfo.student);
        }
        fetchStudentData();
    }, [BeURL])

    const menuItems = [
        { name: "Courses", path: "/learner/courses", icon: FiBook },
        { name: "My Courses", path: "/learner/my-courses", icon: FiAward },
    ];

    const isActive = (path) => location.pathname === path;

    const handleLogoutClick = () => {
        handleLogout();
        window.location.href = '/';
    };

    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    if (loading || isAuth == null || currentUser == null) return <Loading />

    return (
        <div className="bg-gray-50 h-screen flex flex-col lg:flex-row">
            {/* ✅ Sidebar */}
            <aside
                className={`
                    fixed inset-y-0 left-0 z-50 bg-white border-r border-gray-200 shadow-lg
                    transform transition-transform duration-300 ease-in-out
                    ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
                    w-64
                    lg:translate-x-0 lg:static lg:flex lg:flex-col
                `}
            >
                {/* Header */}
                <div className="h-16 flex items-center justify-between px-4 border-b">
                    <div onClick={() => navigate("/")} className="cursor-pointer">
                        <img src={Logo} alt="logo" className="object-cover h-12" />
                    </div>

                    {/* Mobile close */}
                    <button onClick={toggleSidebar} className="lg:hidden">
                        <FiX size={22} />
                    </button>
                </div>

                {/* Menu */}
                <nav className="flex-1 px-3 py-6 space-y-2 overflow-y-auto">
                    {menuItems.map((item) => {
                        const Icon = item.icon;
                        return (
                            <Link
                                key={item.path}
                                to={item.path}
                                onClick={() => setSidebarOpen(false)}
                                className={`flex items-center gap-3 px-3 py-3 rounded-lg transition-all duration-200 ${isActive(item.path)
                                    ? 'bg-gradient-to-r from-primary-600 to-primary-700 text-white'
                                    : 'text-gray-700 hover:bg-gray-100 hover:text-primary-600'
                                    }`}
                            >
                                <Icon size={20} />
                                <span>{item.name}</span>
                            </Link>
                        );
                    })}
                </nav>

                {/* Footer */}
                <div className="border-t p-3">
                    <button
                        onClick={handleLogoutClick}
                        className="w-full flex items-center gap-3 px-3 py-3 text-red-600 hover:bg-red-50 rounded-lg"
                    >
                        <FiLogOut size={20} />
                        Logout
                    </button>
                </div>
            </aside>

            {/* Overlay (Mobile) */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
                    onClick={toggleSidebar}
                ></div>
            )}

            {/* Main Content */}
            <div className="flex-1 flex flex-col overflow-hidden ">

                {/* Header */}
                <header className="h-16 bg-white border-b shadow-sm">
                    <div className="h-full px-4 sm:px-6 flex items-center justify-between">

                        {/* Mobile Menu Button */}
                        <div className="lg:hidden flex items-center gap-2">
                            <button
                                onClick={toggleSidebar}
                                className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
                            >
                                <FiMenu size={22} />
                            </button>

                            <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-primary-600 to-secondary-600 flex items-center justify-center">
                                <span className="text-white font-bold text-sm">S</span>
                            </div>
                        </div>

                        {/* Right Section */}
                        <div className="ml-auto flex items-center gap-4">

                            {/* Notification */}
                            <button
                                onClick={() => navigate('/learner/notifications')}
                                className="relative p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
                            >
                                <FiBell size={20} />
                                <span className="absolute top-1 right-1 w-2.5 h-2.5 bg-red-500 rounded-full animate-pulse"></span>
                            </button>

                            {/* Cart */}
                            <button
                                onClick={() => navigate('/learner/cart')}
                                className="p-2 text-gray-600 hover:bg-gray-100 rounded-lg"
                            >
                                <FiShoppingCart size={20} />
                            </button>

                            {/* User */}
                            <div className="relative">
                                <button
                                    onClick={() => setUserMenuOpen(!userMenuOpen)}
                                    className="flex items-center gap-2 p-2 rounded-lg hover:bg-gray-100"
                                >
                                    <div className="w-8 h-8 rounded-full bg-gradient-to-br from-primary-600 to-secondary-600 flex items-center justify-center text-white">
                                        {currentUser?.fullName?.charAt(0) || 'U'}
                                    </div>
                                    <FiChevronDown />
                                </button>

                                {userMenuOpen && (
                                    <div className="absolute right-0 mt-2 w-44 bg-white rounded-lg shadow-lg border z-50">
                                        <Link
                                            to="/learner/profile"
                                            className="block px-4 py-2 hover:bg-gray-100"
                                        >
                                            Profile
                                        </Link>
                                        <button
                                            onClick={handleLogoutClick}
                                            className="w-full text-left px-4 py-2 text-red-600 hover:bg-red-50"
                                        >
                                            Logout
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </header>

                {/* Content */}
                <main className="flex-1 overflow-auto">
                    <div className="px-4 sm:px-6 lg:px-8 py-6">
                        <Outlet context={{ student }} />
                    </div>
                </main>
            </div>
        </div>
    )
}

export default StudentLayout;